import type { SupabaseClient } from '@supabase/supabase-js';
import { createClientOnlyFn } from '@tanstack/react-start';

import type { CleanNotificationWithRelations } from '~/database/supabase/notifications/types.ts';

interface UpdateNotificationViewedStatusProps {
	readonly accessToken: string | undefined;
	readonly notification: CleanNotificationWithRelations;
	readonly supabaseClient: SupabaseClient | undefined;
}

export const updateNotificationViewedStatusClient = createClientOnlyFn(
	async ({ accessToken, notification, supabaseClient }: UpdateNotificationViewedStatusProps) => {
		const { updateNotificationViewedStatus } = await import('~/database/supabase/notifications/queries.client.ts');

		return updateNotificationViewedStatus({
			accessToken,
			notification,
			supabaseClient,
		});
	},
);
